import React, { Component } from "react";
import "./DictionaryItem.css";
import Action from "./../../../../../formElements/Action/Action";
import audioImg from "./images/audio.svg";
import noAudioImg from "./images/noAudio.svg";

export default class DictionaryItem extends Component {
  render() {
    return (
      <div className="dictionary-item">
        <DictionaryItemHeader word={this.props.word} pos={this.props.pos} />
        {this.props.items.map((item, index) => (
          <DefinitionItem key={index} item={item} />
        ))}
        <div className="separator"></div>
      </div>
    );
  }
}

class DictionaryItemHeader extends Component {
  render() {
    return (
      <div className="dictionary-item-header">
        <span>{this.props.pos}</span>
      </div>
    );
  }
}

class PronunciationAudio extends Component {
  constructor(props) {
    super(props);

    this.onAudioPlay = this.onAudioPlay.bind(this);
  }

  onAudioPlay() {
    this.audioElement && this.audioElement.play && this.audioElement.play();
  }

  render() {
    if (this.props.pronunciation) {
      return (
        <div className="pronunciation">
          <span>
            <Action className="audio-btn" onClick={this.onAudioPlay}>
              <img src={audioImg} alt="audio" />
            </Action>
            <audio controlsList="nodownload" ref={c => (this.audioElement = c)}>
              <source src={this.props.pronunciation} />
            </audio>
          </span>
        </div>
      );
    } else {
      return (
        <div className="pronunciation">
          <img src={noAudioImg} alt="no audio available" />
        </div>
      );
    }
  }
}

class PronunciationTranscript extends Component {
  render() {
    return (
      this.props.pronunciation && (
        <div className="transcription">
          <Transcription text={`/${this.props.pronunciation}/`} />
        </div>
      )
    );
  }
}

class DefinitionItem extends Component {
  render() {
    const pronAudio = (
      <PronunciationAudio pronunciation={this.props.item.pronunciation.audio} />
    );
    const pronTranscript = (
      <PronunciationTranscript pronunciation={this.props.item.pronunciation.phonetic} />
    );
    return (
      <div className="definition-item">
        <div>
          {pronAudio}
          {pronTranscript}
          <span className="definition">{this.props.item.definition}</span>
          {/* For now, we don't show a term's domain.
          { this.props.item.domain &&
            <span className="domain">({ this.props.item.domain })</span>
          }
          */}
        </div>
        <div className="examples-list">
          {this.props.item.examples.map((ex, index) => (
            <DefExample key={index} content={ex} />
          ))}
        </div>
      </div>
    );
  }
}

class DefExample extends Component {
  render() {
    return <div className="example">{this.props.content}</div>;
  }
}

class Transcription extends Component {
  render() {
    return <span>{this.props.text}</span>;
  }
}
